var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHyundai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 27.68c8.28 0 15-3.44 15-7.68s-6.72-7.68-15-7.68S5 15.76 5 20s6.72 7.68 15 7.68m2.82-3.77a4.24 4.24 0 01-1.67 2.31 2.67 2.67 0 01-1 .24H20a26 26 0 01-7.5-1.05h-.08c-.2-.06-.3-.16-.3-.27a.33.33 0 01.12-.24l.14-.12a17.25 17.25 0 014.82-2.59A23 23 0 0120.73 21c.76-.16 3.58-.6 2.09 2.87m7.58-7.74a.34.34 0 01.26-.18.58.58 0 01.31.1c1.76 1.09 2.8 2.44 2.8 3.91 0 2.65-3.4 4.92-8.27 5.92-.31.06-.52.06-.59 0s-.07-.13 0-.24a1.08 1.08 0 01.13-.18 39.39 39.39 0 005.24-9.07l.12-.24m-13.18-.1a4.24 4.24 0 011.67-2.31 2.48 2.48 0 011-.23H20a26.41 26.41 0 017.51 1h.08q.3.09.3.27a.34.34 0 01-.13.24l-.13.12a17.51 17.51 0 01-4.82 2.58A24.91 24.91 0 0119.32 19c-.77.16-3.59.59-2.1-2.88m-2.72-2c.31-.06.52-.06.6 0a.21.21 0 010 .24.77.77 0 01-.13.17 39.39 39.39 0 00-5.24 9.07c0 .1-.09.19-.12.25a.29.29 0 01-.25.17.51.51 0 01-.36-.12c-1.76-1.08-2.8-2.44-2.8-3.9 0-2.65 3.4-4.93 8.27-5.92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyundai);
export default __webpack_public_path__ + "static/media/hyundai.1dc038c0af43ec18cb72f20ac2a5b389.svg";
export { ForwardRef as ReactComponent };